import { Button, Table } from "antd";
import { useSelector } from "react-redux";

import classes from "./BookingsTable.module.scss";

export default function BookingTable({
  columns,
  data,
  filters,
  loading,
  onClearFilters,
  onTableChange,
}) {
  const total = useSelector((state) => state.bookings.meta.total);
  const currentPage = useSelector((state) => state.bookings.meta.currentPage);
  const pageSize = useSelector((state) => state.bookings.meta.pageSize);
  const { page, size, ...realFilters } = filters;

  return (
    <div className={classes.table}>
      <Button
        disabled={!Object.keys(realFilters).length}
        size="small"
        onClick={onClearFilters}
      >
        Clear filters
      </Button>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        size="middle"
        pagination={{
          position: ["bottomCenter"],
          pageSize,
          current: currentPage + 1,
          total,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        onChange={onTableChange}
      />
    </div>
  );
}
